import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { removeWorkFromAssessmentFile } from '../../../../../../../stores/works/works.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getWork } from '../../../../../../../stores/works/works.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id, match }) => {
  const work = getWork(state, id)
  return {
    id: work.id,
    assessmentFileId: match.params.assessmentFileId
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onRemove: assessmentFileId => {
    return dispatch(
      removeWorkFromAssessmentFile(ownProps.id, assessmentFileId)
    ).catch(errorHandler)
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(ContextMenu)
)
